<template>
    <section id="today" class="container">
        <div class="container mt-3" >

            <b-card-group deck>
                <b-card border-variant="success" align="center">
                    <ChartDemo></ChartDemo>
                </b-card>
            </b-card-group>


        </div>
    </section>
</template>

<script>
    //import api from '../../../../api.js'
    import ChartDemo from '../charts/Demo'
    export default {
        name: "Admin",
        components:{ChartDemo},
        props:{
            filters: {
                type : Object,
                required: true
            },
            triggerSearch:{
                type : Number,
                required: true
            }
        },
        data(){
            return {
                loaded: false
            }
        },
        methods:{

        },
        mounted(){
            this.loaded=true;
        },
        watch:{

        }
    }
</script>

<style scoped>

</style>